import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
  name: "math",
  initialState: {
    count: 0
  },
  reducers: {
    plusCount: (state) => {
      state.count = state.count + 1;
    },
    minusCount: (state) => {
      state.count = state.count - 1;
    }
  },
})

export const { plusCount, minusCount } = slice.actions
export const math = slice.reducer